/**
 * Istanza condivisa di TanStack QueryClient.
 *
 * Configurazione:
 * - staleTime 30s: i dati sono considerati freschi per 30 secondi dopo il fetch,
 *   evitando refetch automatici troppo frequenti nella navigazione.
 * - retry 1: in caso di errore riprova una sola volta prima di propagare l'errore.
 * - refetchOnWindowFocus false: non rifetchare ad ogni focus della finestra
 *   (preferibile in un portale B2B dove i dati non cambiano ad alta frequenza).
 */

import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './client.js';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30 secondi
      // No retry on auth errors: a second attempt would fire without a token (already cleared)
      // and generate a spurious auth_failure audit event with actor=anonymous.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && (error.status === 401 || error.status === 403))
          return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});
